export enum FiltersPersonSearch {
  FiscalCode = 1,
  SubjectData = 2,
  IdentityCard = 3,
  ResidencePermit = 4,
  Family = 5,
}
